import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { costs } from '../data/problems';
export function ProblemSection() {
  return <section className="bg-white py-16 sm:py-20" aria-labelledby="problem-title" data-id="element-149" data-mp="30hzhn1ayjuld">
      <div className="mx-auto max-w-4xl px-4" data-id="element-150" data-mp="2vpg587o0b5i5">
        <div className="text-center" data-id="element-151" data-mp="2voo82sergzpr">
          <SectionHeading id="problem-title" data-id="element-152" data-mp="39h4fs6ilxlx0">Does This Sound <span className="text-teal-700" data-id="element-153" data-mp="39jyztwxpl4pw">Familiar?</span></SectionHeading>
          <p className="mx-auto mt-6 max-w-3xl text-lg leading-relaxed text-slate-600" data-id="element-154" data-mp="35fivi03qu5cs">
            You work in instrumentation, control or automation, but process control and SCADA systems still feel like
            separate pieces. When someone talks about loop dynamics, PID tuning, DCS redundancy, telemetry, industrial
            protocols or alarm management, you can&apos;t connect all the pieces with confidence.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-10 rounded-xl border border-slate-200 bg-slate-50 p-6 sm:p-8" data-id="element-155" data-mp="jd3kgf4mzvn7">
          <p className="mb-5 inline-flex items-center gap-2 text-xl font-semibold text-slate-900" data-id="element-156" data-mp="x4s18vptz8ai">
            <AlertTriangleIcon className="h-5 w-5 text-amber-600" aria-hidden="true" data-id="element-157" data-mp="124ee341qymis" />
            The real cost:
          </p>
          <ul className="grid gap-4 sm:grid-cols-2" data-id="element-158" data-mp="1714qnhecezzg">
            {costs.map(item => <li key={item} className="flex gap-3 text-sm leading-relaxed text-slate-600" data-id="element-159" data-mp="1c2u413p1fpqp">
                <span className="mt-1.5 h-2 w-2 shrink-0 rounded-full bg-teal-700" aria-hidden="true" data-id="element-160" data-mp="1g3nti1i4pclp" />
                {item}
              </li>)}
          </ul>
        </motion.div>

        <div className="mt-10 text-center" data-id="element-161" data-mp="3huh9gpw13vu8">
          <p className="mx-auto max-w-2xl text-lg font-semibold text-slate-900" data-id="element-162" data-mp="3hv97s8h0g7o7">
            You don&apos;t need more scattered information.
          </p>
          <p className="mt-3 text-2xl font-bold tracking-tight text-teal-700 sm:text-3xl" data-id="element-163" data-mp="k1foy2z87pgh">You need one organized system.</p>
        </div>
      </div>
    </section>;
}